/**
 * Period rows (months, qtrs, hlvs, seasons, cals) are anchored to "now in London",
 * not the user's local wall-clock. This avoids users in other timezones seeing
 * the grid roll forward (or stay back) compared to London near month boundaries.
 */
const londonParts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
});
/** @deprecated Use the Artis API instead: `artis.v1.offsets.getBaseMonth()`, or `getBaseMonth` from `@artis/sdk`. */
export const londonNow = () => {
    const parts = {};
    for (const { type, value } of londonParts.formatToParts(new Date())) {
        parts[type] = value;
    }
    return new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
};
//# sourceMappingURL=time.js.map